import React from 'react';
import Layout from '../../../components/ui/Layout';
import PaginatedProducts from './PaginatedProducts';
import ProductsDashboard from '../../../components/admin/ProductsDashboard';
import BreadcrumbNavigation from '../../../components/ui/BreadcrumbNavigation'; // Import Breadcrumb
import { Button, Container, Row, Col } from 'react-bootstrap'; // Import Button, Container, Row, Col
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useAuth } from '../../../components/context/AuthContext';

export default function ProductsPage() {
  const navigate = useNavigate();
  const { userRole } = useAuth();

  const breadcrumbItems = [
    { path: "/", label: "Home" },
    { path: "/admin", label: "Admin Panel" },
    { label: "Products Management" } // Current page
  ];

  return (
    <Layout>
      <Container className="mt-4 px-3">
        <Row className="align-items-center mb-1">
          <Col xs="auto">
            <Button variant="outline-secondary" onClick={() => navigate(-1)} className="mb-2">
              &larr; Go Back
            </Button>
          </Col>
          <Col>
            <BreadcrumbNavigation items={breadcrumbItems} />
          </Col>
        </Row>
        {/* Products Dashboard - Only visible to Admins */}
        {userRole === 'Admin' && <ProductsDashboard />}
        {/* The PaginatedProducts component already includes an H1 and a conditional Create button */}
        <PaginatedProducts />
      </Container>
    </Layout>
  );
}
